@if (showContainerTab()) {
  <app-tab-panel class="col-12" [alwaysRender]="true">
    <app-tab-item [templateRef]="cargoTab">
      <span class="tab-item">Cargo</span>
      <ng-template #cargoTab>
        <div class="card">
          <div class="card-body p-4">
            <ng-container [ngTemplateOutlet]="cargoBody" />
          </div>
        </div>
      </ng-template>
    </app-tab-item>
    <app-tab-item [templateRef]="containerTab">
      <span class="tab-item">Container</span>
      <ng-template #containerTab>
        <div class="card">
          <div class="card-body p-4">
            <app-berth-visit-container-rotterdam
                [berthVisitNumber]="berthVisitNumber()"
                [showLoading]="showContainerHandlingLoading()"
                [showDischarge]="showContainerHandlingDischarge()"
                [showValidationErrors]="showValidationErrors()" />
          </div>
        </div>
      </ng-template>
    </app-tab-item>
  </app-tab-panel>
} @else if (hasLoadedGoods() || hasDischargedGoods()) {
  <ng-container [ngTemplateOutlet]="cargoBody" />
} @else {
  <app-form-field
      class="col-12"
      label="Visit purpose(s)"
      [includeMargin]="false"
      [value]="berthVisit()?.visitPurposes?.join(', ')"
      [editMode]="false" />
}

<ng-template #cargoBody>
  @if (hasLoadedGoods()) {
    <app-berth-visit-cargo-rotterdam
        [berthVisitNumber]="berthVisitNumber()"
        [lookupCargoTypes]="harbourDuesDetails()?.lookupCargoTypes"
        [mode]="CargoComponentMode.LOADING" />
  }
  @if (hasDischargedGoods()) {
    <app-berth-visit-cargo-rotterdam
        [class]="{'mt-4': hasLoadedGoods()}"
        [berthVisitNumber]="berthVisitNumber()"
        [lookupCargoTypes]="harbourDuesDetails()?.lookupCargoTypes"
        [mode]="CargoComponentMode.DISCHARGE" />
  }
</ng-template>
